var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgT(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8155 0L14 3.75221H13.5325C13.4423 3.09145 13.3193 2.61947 13.1634 2.33628C12.9092 1.88004 12.5688 1.54572 12.1424 1.33333C11.7241 1.11308 11.1705 1.00295 10.4815 1.00295H8.13181V13.2271C8.13181 14.2104 8.24253 14.824 8.46397 15.0678C8.77563 15.3982 9.25542 15.5634 9.90334 15.5634H10.4815V16H3.40773V15.5634H3.99824C4.70357 15.5634 5.20387 15.3589 5.49912 14.9499C5.67955 14.6981 5.76977 14.1239 5.76977 13.2271V1.00295H3.7645C2.98535 1.00295 2.43175 1.05801 2.10369 1.16814C1.67721 1.3176 1.31224 1.60472 1.00879 2.0295C0.705331 2.45428 0.524897 3.02852 0.467487 3.75221H0L0.196837 0H13.8155Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgT);
export default __webpack_public_path__ + "static/media/T.12d63cad0aaa6c9c4a744d5d983479d2.svg";
export { ForwardRef as ReactComponent };